import React from "react";

import { IStaticElementUnion } from "@graffer-inc/form-schema";

type Props = {
  element: IStaticElementUnion;
};

export const StaticElementCommonPropertiesEditor: React.FC<Props> = ({
  element,
}) => {
  const labelId = `${element.id}-label`;
  return (
    <>
      <div className="field">
        <label className="label" htmlFor={labelId}>
          項目名
        </label>
        <div className="control">
          <p id={labelId}>{element.label.text}</p>
        </div>
        <p className="help">入力画面では表示されません。</p>
      </div>
      <div className="field">
        <label className="label">表示・非表示設定</label>
        <div className="control">
          <p>{element.hidden ? "非表示" : "表示"}</p>
        </div>
      </div>
    </>
  );
};
